import { Blueprint } from '../../blueprint.class';
import { ToolResult } from '../../types';

export interface AddCutoutArgs {
	sku: string;
	islandId: string;
}

export const addCutoutTool = (blueprint: Blueprint, { sku, islandId }: AddCutoutArgs): ToolResult<{ cutoutId: string }> => {
	if (!sku) return { success: false, error: 'Missing sku. Use get_appliances with category "Cutouts" to get available cutout SKUs.' };
	if (!islandId) return { success: false, error: 'Missing islandId. Use list_islands to get valid island IDs.' };

	const kitchen = blueprint.kitchens.getActiveVersion();
	if (!kitchen) return { success: false, error: 'No active kitchen found.' };

	const island = kitchen.design.islands.children.find((i) => i.id === islandId);
	if (!island) return { success: false, error: `Island '${islandId}' not found. Use list_islands to get valid island IDs.` };

	// Verify SKU exists
	const component = blueprint.context.components.findSku(sku);
	if (!component) return { success: false, error: `SKU '${sku}' not found. Use get_appliances with category "Cutouts" to get available cutout SKUs.` };

	// Adding to front panel as default action
	const frontPanel = island.panels.children.find((p) => p.id === island.panels.frontPanelId);
	if (!frontPanel) return { success: false, error: `Front panel for island '${islandId}' not found.` };

	// Get or create a panel item group
	let [group] = frontPanel.panelItemGroups.children;
	if (!group) {
		group = frontPanel.panelItemGroups.new();
	}

	const cutout = group.items.newFromSku(sku);

	// Center items vertically after adding
	group.centerItemsVertically();

	return { success: true, message: `Cutout '${sku}' added to island '${islandId}'.`, data: { cutoutId: cutout.id } };
};
